import {
  DashboardVersion,
  isDashboardVersion,
} from '@interfaces/dashboardVersion';

export const DASHBOARD_VERSION_SESSION_KEY = 'dashboard-version';

/**
 * A escolha desta aba, para a home não voltar atrás ao remontar.
 *
 * A coluna em `platform_user` é a preferência de verdade, mas a sessão do NextAuth é cacheada no cliente e a
 * 4.19.2 não expõe `update()` — `getSession` só avisa OUTRAS abas, porque o evento `storage` não dispara em
 * quem escreveu. Sem este espelho, ir a um relatório e voltar remontava a home com o valor velho da sessão.
 *
 * `sessionStorage` e não `localStorage`: o escopo é a aba, e quando ela fecha a preferência do banco volta a
 * ser a única fonte. Guardado com o id do dono porque logout não limpa `sessionStorage` — sem isso, quem
 * entrasse depois na mesma aba herdava a escolha do anterior.
 */
export const getVisitDashboardVersion = (
  userId: number | undefined,
): DashboardVersion | null => {
  if (!userId) return null;

  try {
    const stored = JSON.parse(
      sessionStorage.getItem(DASHBOARD_VERSION_SESSION_KEY) ?? 'null',
    );

    return stored?.userId === userId && isDashboardVersion(stored.version)
      ? stored.version
      : null;
  } catch {
    return null;
  }
};

export const setVisitDashboardVersion = (
  userId: number | undefined,
  version: DashboardVersion,
) => {
  if (!userId) return;

  try {
    sessionStorage.setItem(
      DASHBOARD_VERSION_SESSION_KEY,
      JSON.stringify({ userId, version }),
    );
  } catch {
    // Navegador com storage bloqueado: a troca vale nesta tela e o PATCH continua sendo a fonte.
  }
};
